const USER_ASSIGNMENT_ACTION_TYPE = {
  TIER_ONE: 'TIER_ONE',
  CURATION: 'CURATION',
  QA: 'QA',
  QC: 'QC',
  UNKNOWN_WORDS_CURATION: 'UNKNOWN_WORDS_CURATION',
  UNKNOWN_WORDS_QA: 'UNKNOWN_WORDS_QA',
  SCRAPING_REVIEW: 'SCRAPING_REVIEW',
}

export default USER_ASSIGNMENT_ACTION_TYPE
